import type * as api from '@gitbook/api-client';

import { useRealtimeChannel } from '../../state';

/**
 * Get the current progress of a translation run.
 */
export function useTranslationProgress(
    translationId: string,
    options?: { skip?: boolean }
): api.TranslationRunChannelData['data'] | null {
    const progress = useRealtimeChannel(
        {
            channel: 'translation-run',
            translation: translationId,
        },
        undefined,
        options
    );

    return progress;
}

/**
 * Get the estimated time remaining for a translation run.
 */
export function getTranslationEstimatedTimeRemaining(data: api.TranslationRunChannelData['data']) {
    const progress = data.progress;

    if (progress === 0) {
        return 'Unknown';
    }

    const startedAt = new Date(data.startedAt);
    const updatedAt = new Date(data.updatedAt);

    const duration = updatedAt.getTime() - startedAt.getTime();
    const remaining = (duration * (100 - progress)) / progress;

    return formatDuration(remaining);
}

function formatDuration(duration: number) {
    const hours = Math.floor(duration / 3600000);
    const minutes = Math.floor((duration % 3600000) / 60000);
    const seconds = Math.floor((duration % 60000) / 1000);

    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    }

    if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
    }

    return `${seconds}s`;
}
